export default "__VITE_ASSET__Bd_EetO8__"